import { cn } from '../../../lib/stylingUtils';

const scrollShadowVariants = cn(
  'bg-white',
  'relative before:pointer-events-none',
  'before:absolute before:inset-x-0 before:bottom-full',
  'before:h-[30px] before:bg-[linear-gradient(0deg,rgba(7,20,41,0.05)_0%,rgba(255,255,255,0)_100%)]',
);

export const Footer = ({
  className,
  displayShadow = false,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { displayShadow?: boolean }) => (
  <div
    className={cn(
      '@Footer',
      'flex flex-none flex-row justify-end border-t border-neutral/10 bg-neutral/5 p-2',
      displayShadow && scrollShadowVariants,
      className,
    )}
    {...props}
  />
);

type FooterItemProps = {
  label: string;
  children: React.ReactNode;
  className?: string;
};

export const FooterItem: React.FC<FooterItemProps> = ({
  label,
  children,
  className,
}) => (
  <div
    className={cn('@FooterItem', 'flex min-h-15 flex-col items-end', className)}
  >
    <span className="text-xs font-medium text-neutral/60 uppercase">
      {label}
    </span>
    <div className="flex justify-end">{children}</div>
  </div>
);
